import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";
import {
  Box,
  styled,
  Typography,
  Grid,
  SelectChangeEvent,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import * as Yup from "yup";
import { StyledButton } from "../../../shared/components/buttons/custom-button";
import FormBuilder from "../../../shared/components/form-builder/form-builder";
import { OptionType } from "../../../shared/components/form-builder/form-config.model";
import CustomTable from "../../../shared/components/table/custom-table";
import { CustomSelect } from "../../../shared/components/inputfields/form-elements";
import { useFormActions } from "../../../shared/hooks/form-builder.hooks";
import useRecordsStore, { Pagination } from "../../../shared/hooks/useRecordStore";
import { useTransactionCertificateStore } from "../../../store/transaction-certificates.store";
import { TCAppConfig } from "../../../shared/app-configs/tc-app-configs";
import { useApi } from "../../../shared/hooks/useApi";
import { ETCAppConfig } from "../../../shared/app-configs/etc-app-configs";
import { Utills } from "../../../shared/app-configs/utilit";
import { getColumnsBySource } from "../../transaction-certificates/tc-dashboard/cbLandingPageTable.config";
import { dtrackItService } from "../../transaction-certificates/tc-service/dtrackit.service";

export const PageWrapper = styled("div")({
  padding: "0 25px 0px 25px",
  display: "grid",
  overflowY: "auto",
  flexDirection: "column",
  gap: "12px",
  flex: 1,
});

const TCSuppliersDashboard = () => {
  const formRef = useRef<any>(null);
  const { resetAllDatas } = useFormActions("")
    const [productCategory, setProductCategory] = useState([]);
    const [productDetails, setProductDetails] = useState([]);
  const { setDelayReason, setTCIssueDate } = useTransactionCertificateStore();

  const { setNewTCRequested } = useTransactionCertificateStore();

  const links: OptionType[] = [
    { label: "TP1", value: "item1" },
    { label: "TP2", value: "item2" },
  ];
  const { executeGet } = useApi();

  const [singleValue, setSingleValue] = React.useState<string | number>("");
  const {
    suppliersData,
    fetchRecords,
    selectedSource,
    isLoading,
  } = useRecordsStore();
  const [pagination, setPagination] = useState<Pagination>({
    pageIndex: 0,
    pageSize: 10,
  });
  const [rowCount, setRowCount] = useState<number>(0)
  const filteredData = suppliersData
  Utills.cl(suppliersData)
  const columns = useMemo(() => getColumnsBySource('suppliers'),
    [selectedSource]);
  const [countries, setCountries] = useState([]);

  const [isResetEnabled, setResetEnable] = useState(false);
    const getProductCategory = async () => {
      try {
        const result: any = await dtrackItService.getProductCategory()

        // Utills.cl(`result ${JSON.stringify(result)}`)

        const prdtCategory = result.data.map((t: any) => ({ value: t.code_1, label: `${t.description_1} (${t.code_1})` }))
        Utills.cl(`prdtCategory ${JSON.stringify(prdtCategory)}`)
        setProductCategory(prdtCategory);
      } catch (err) {
        Utills.cl(`Error in Fetching Organic Farm Standard Code ${err}`)
      }
    };

    const getProductDetails = async () => {
      try {
        const result: any = await dtrackItService.getProductDetailsCode()

        Utills.cl(`result getProductDetails ${JSON.stringify(result)}`)

        const prdtDetails = result.data.map((t: any) => ({ value: t.code_1, label: `${t.description_1} (${t.code_1})` }))
        Utills.cl(`prdtDetails ${JSON.stringify(prdtDetails)}`)
        setProductDetails(prdtDetails);
      } catch (err) {
        Utills.cl(`Error in Fetching Organic Farm Standard Code ${err}`)
      }
    };
  useEffect(() => {
    const loadData = async () => {
      await fetchRecords({
        teId: "TE-01",
        source: 'suppliers',
        pagination,
        rowCount,
        setRowCount,
        tcCbLicensingCode: ""
      });
    };
    loadData();
    
  }, [pagination.pageIndex, pagination.pageSize, selectedSource]);

  useEffect(() => {
    setDelayReason(false)
    setTCIssueDate("")
    resetAllDatas();
    getProductDetails();
    getProductCategory();
  }, []);

  const formConfig = {
    pageName: "cb-suppliers-landing-page",
    initialValues: {
      buyersCountry: [], // For multi-select
      startDate: null,
      endDate: null,
      source: "",
    },
    validationSchema: Yup.object().shape({
      buyersCountry: Yup.array().nullable(),
      startDate: Yup.string().nullable(),
      endDate: Yup.string().nullable(),
    }),
    sections: [
      {
        fields: [
         
          {
            label: "Issued Start Date",
            name: "startDate",
            type: "date",
            gridSize: { xs: 12, md: 3, lg: 3 },
            required: false,
            props: {
              placeholder: "Select Start Date",
              disableFuture:false
            },
          },
          // End Date Field
          {
            label: "Issued End Date",
            name: "endDate",
            type: "date",
            gridSize: { xs: 12, md: 3, lg: 3 },
            required: false,
            props: {
              placeholder: "Select End Date",
              disableFuture:false
            },
          },
          // {
          //   label: 'Product Category',
          //   name: 'productCategory',
          //   type: 'select',
          //   gridSize: { xs: 12, md: 6, lg: 3 },
          //   required: true,
          //   props: {
          //     options: productCategory,
          //     placeholder: 'Select Product Category',
          //   },
          // },
          // {
          //   label: 'Product Detail',
          //   name: 'productDetail',
          //   type: 'select',
          //   gridSize: { xs: 12, md: 6, lg: 3 },
          //   required: true,
          //   props: {
          //     options: productDetails,
          //     placeholder: 'Select Product Detail',
          //   },
          // },
        ],
      },
    ],
    handleSubmit: async (values: any) => {
      await getCBLandingPageRecords(values);
    },
  };

  const getCBLandingPageRecords = async (values: any) => {
    try {

      if (values.startDate != null || values.endDate != null) {
        setResetEnable(true)
      }
      // setSelectedSource(values.source); -- this is required when we want to attach the source to the search params
      await fetchRecords({
        startDate: values.startDate,
        endDate: values.endDate,
        source: "suppliers",
        pagination: pagination,
        rowCount: rowCount,
        setRowCount,
        tcCbLicensingCode: ""
      });
    } catch (error) {
      Utills.cl("Error fetching data: ", error);
    }
  }

  const handleRowClick = () => {
    setNewTCRequested(false)
  };

  const handleSubmit = () => {
    if (formRef.current) {
      formRef.current.submitForm();
    }
  };

  const handleReset = async () => {
    formRef.current.resetForm();
    const params = {
      teId:"TE-01",
      startDate: null,
      endDate: null,
      source: "suppliers",
      pagination: pagination
    }
    setResetEnable(false)
    await getCBLandingPageRecords(params);
  }

  const handleSingleChange = (
    event: SelectChangeEvent<string | number | string[]>
  ) => {
    setSingleValue(event.target.value as string | number);
  };
  Utills.cl(columns, filteredData);

  return (
    <>
      <PageWrapper>
        <Typography variant="h6" gutterBottom align="left" fontWeight={"600"}>
          Suppliers Transactions
        </Typography>
        <Box
          display="flex"
          justifyContent="flex-end" // Align items to the end of the container
          alignItems="center" // Vertically center the button and select
          width="100%" // Make the box span the entire width
          mb="12px"
          gap={2} // Add gap for spacing between elements
        >
          <Grid md={2} lg={2}>
            <CustomSelect
              size="small"
              value={singleValue}
              options={links}
              placeholder="Login To"
              onChange={handleSingleChange}
              sx={{ minWidth: '180px', height: '40px' }} // Ensure consistent select height
            />
          </Grid>
        </Box>
        <FormBuilder
          formConfig={formConfig}
          onSubmit={formConfig.handleSubmit}
          formRef={formRef}
        />
        {/* </Grid> */}

        <Grid
          item
          md={2}
          lg={2}
          display="flex"
          justifyContent={"flex-end"}
          alignItems="center"
        >
          <StyledButton onClick={handleSubmit}>Search</StyledButton>
          {isResetEnabled ?
            <StyledButton onClick={handleReset}>Reset</StyledButton>
            : null
          }
        </Grid>

        {/* </Grid> */}

        <CustomTable
          key={selectedSource}
          columns={columns}
          data={filteredData}
          title="TransactionData"
          enableTopToolbar={true}
          enableBottomToolbar={true}
          // enableColumnOrdering={false}
          paginations={pagination} // Pass current pagination state
          setPaginations={setPagination}
          rowCount={rowCount}
          isLoadingTodos={isLoading}
          onClickRow={handleRowClick}
        />
      </PageWrapper>

    </>
  );
};

export default TCSuppliersDashboard;
